<template>
  <BaseLink
    type="button"
    class="outfit-card align-items-center unstyled-button"
    @click="onPressFormula">
    <FlatlayLayout
      :layout="formula.template.name"
      :tile-images="images"
      class="mb-sm mb-md-0"/>
    <TextLineLimit
      tag="h4"
      :line-limit="2"
      class="align-self-start align-self-lg-center">
      {{ formula.name }}
    </TextLineLimit>
  </BaseLink>
</template>

<script setup>
import { computed } from 'vue'
import { useOutfitGeneratorStore } from '@/stores/outfitGenerator'
import FlatlayLayout from '@/components/outfitBuilder/flatlays/FlatlayLayout.vue'
import useModals from '@/composables/modals.js'
import TextLineLimit from '@/components/global/sequin/TextLineLimit.vue'
import BaseLink from '@shared/components/BaseLink.vue'


const props = defineProps({
  formula: {
    type: Object,
    required: true
  }
})
const { openOutfitBuilderModal } = useModals()

const outfitGeneratorStore = useOutfitGeneratorStore()
const images = computed(() => outfitGeneratorStore.fullDefaultOutfitImages(props.formula))

const onPressFormula = () => {
  outfitGeneratorStore.selectFormula(props.formula)
  openOutfitBuilderModal()
}
</script>

<style scoped lang="scss">
.outfit-card {
  display: grid;
  grid-template-columns: auto 160px;
  gap: $spacing-sm;
  @include media-tablet-or-smaller {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }
}
</style>